import React from 'react';

export const ServiceCardSkeleton = () => {
  return (
    <div className="w-full sm:w-[288px] bg-white rounded-2xl shadow-lg overflow-hidden">
      {/* Header */}
      <div className="p-4 pb-2">
        <div className="flex items-center gap-1">
          <div className="w-6 h-6 rounded-lg bg-gray-200 animate-pulse"></div>
          <div className="w-20 h-6 bg-gray-200 rounded-lg animate-pulse"></div>
          <div className="ml-auto flex items-center gap-1">
            <div className="w-5 h-5 rounded-full bg-gray-200 animate-pulse"></div>
            <div className="w-8 h-5 bg-gray-200 rounded-lg animate-pulse"></div>
          </div>
        </div>

        {/* Title */}
        <div className="w-3/4 h-[22px] mt-2 bg-gray-200 rounded animate-pulse"></div>
      </div>

      {/* Main Image Section */}
      <div className="h-[166px] bg-gray-200 animate-pulse"></div>

      {/* Services Tags */}
      <div className="px-4 py-2">
        <div className="flex flex-wrap gap-1 h-[68px] mt-1">
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="h-7 w-20 bg-gray-200 rounded-full animate-pulse"
            ></div>
          ))}
        </div>

        <div className="border-t-2 border-gray-200 mt-3"></div>

        {/* Footer Button */}
        <div>
          <div className="w-24 h-8 mx-auto mt-1 mb-1 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};